import React, { useRef } from "react";
import clsx from "clsx";

import Overlay, { OverlayProps } from "../../container/Overlay/Overlay";
import Info, { InfoProps } from "../Info/Info";

export interface InfoOverlayProps extends OverlayProps, InfoProps {}

const InfoOverlay = (props: InfoOverlayProps) => {
	const shownRef = useRef(false);

	let { visible, className, ...otherProps } = props;

	if (visible === undefined) {
		visible = true;
	}

	if (visible) {
		shownRef.current = true;
	}

	return shownRef.current ? (
		<Overlay visible={visible} className={clsx("InfoOverlay", className)}>
			<Info className={clsx(visible && "--visible")} {...otherProps} />
		</Overlay>
	) : null;
};

export default InfoOverlay;
